export const AboutScreen = () => {
  return (
    <></>
    )
};